import React from "react";
import WelcomeBonus from "./WelcomeBonus";
import img from "../assets/VectorCheck.svg";
import img2 from "../assets/cancel.svg";

const FeaturesCom = ({ data }) => {
  return (
    <div className="w-[95vw] h-[100%] rounded-[10px]  border-solid border-[1px] border-black ">
      <div className=" w-[229px] h-[15px]  m-2 mb-0 flex items-center ">
        <p className="ml-1 mt-1text-base font-semibold text-black">Key Features</p>
      </div>

      <div className="grid grid-cols-2 p-4">
        {data.map((item) => (
          <div className="">
            <WelcomeBonus img={item.value ? img : img2} name={item.title} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesCom;
